import { FC, useEffect, useState } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { allcountryList, isNotEmpty } from '../../../../../../_metronic/helpers'
import { User } from '../core/_models'
import clsx from 'clsx'
import { useListView } from '../core/ListViewProvider'
import { UsersListLoading } from '../components/loading/UsersListLoading'
import { createUser, getUserById, updateUser } from '../core/_requests'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { errorToast, successToast } from '../../../../../../_metronic/helpers/components/Toaster'
import { useQuery } from 'react-query'
import UploadImage from '../../../../../../_metronic/helpers/components/ImageUpload'
import Select from 'react-select'
import { useFetchCommon } from '../../../../../../_metronic/helpers/crud-helper/useQuery'
import { useAuth } from '../../../../auth'
import CountryDropDown from '../../../../../../_metronic/helpers/countryDropDown'
import AutoCompleteAddress from '../../../../../../_metronic/helpers/components/AutoCompletePlace'

type Props = {
  isUserLoading: boolean
  user?: User | any
}

export const mapDataForUser = {
  MRF: 'Material Recovery Facility',
  DIVERSION_FACILITY: 'Recycling Facility',
  AGGREGATOR: 'Trader/ Aggregator',
  COLLECTION_TYPE: 'Collection Point',
  // CONVERTER: 'End Customer',
  // TRADER_AGGREGATOR: 'Trader/Aggregator',
}

const editUserSchema = (data) =>
  Yup.object().shape({
    name: Yup.string()
      .min(3, 'Minimum 3 symbols')
      .max(50, 'Maximum 50 symbols')
      .required('Name is required'),
    // proofOfIdentity_num: Yup.string().required('Tax Identification Number is required'),
    // rigid: Yup.string().required('Rigid required'),
    rigid: Yup.string().when('inCategoryId', {
      is: () => data?.some((item) => item.value === 'DIVERSION_FACILITY'),
      then: (schema) => schema.required('Rigid required'), // itemId is required if categoryId exists
      otherwise: (schema) => schema.notRequired(), // No validation if categoryId is absent
    }),
    country: Yup.string().required('Country required'),
    state: Yup.string().required('state required'),
    city: Yup.string().required('city required'),
    inCategoryId: Yup.string().required('Select facility type'),

    // auditorStaff: Yup.string().required('Auditor Staff required'),
    // weightScale: Yup.string().required('Weight Scale required'),
    latitute: Yup.number().required('latitute required'),
    longitute: Yup.number().required('longitute required'),
    // proofEstablishment_num: Yup.string().required('Business Identification Number required'),
    ...((data.length &&
      data?.some((item: { label: string; value: string }) => item.value === 'CONVERTER') &&
      {}) || {
      // facilityManager: Yup.string().required('Facility Manager required'),
      facilityManager: Yup.array()
        .of(
          Yup.object().shape({
            label: Yup.string().required('Label is required'),
            value: Yup.string().required('Value is required'),
          })
        )
        .min(1, 'Facility Manager required'),
      facilityStaff: Yup.string().required('Mobile App Users'),
    }),

    // address: Yup.string()
    //   .min(3, 'Minimum 3 symbols')
    //   .max(50, 'Maximum 50 symbols')
    //   .required('Address is required'),
    // mobileNumber: Yup.string()
    //   .min(3, 'Minimum 3 symbols')
    //   .max(15, 'Maximum 50 symbols')
    //   .required('Mobile number is required'),
  })

const UnitMeasurementModalForm: FC<Props> = ({ user = {}, isUserLoading }) => {
  const { setItemIdForUpdate } = useListView()
  const { refetch } = useQueryResponse()

  const filterSpecificData = (data, name, key = 'docType', displayData = 'docUrl') => {
    return data?.filter((x) => x[key] === name)?.[0]?.[displayData] || ''
  }

  const [address, setAddress] = useState('')
  const [location, setlocation] = useState<any>({})
  useEffect(() => {
    if (Object.keys(user).length > 0 && user?.address?.street) {
      setAddress(user?.address?.street)
      setlocation({ lat: user?.address?.latitute, lng: user?.address?.longitute })
    }
  }, [user])
  const [userForEdit] = useState<any>({
    ...user,
    country: user?.address?.country || '',
    state: user?.address?.state || '',
    city: user?.address?.city || '',
    auditorStaff: user?.auditorId || '',
    weightScale: user?.weightScale?.id || '',
    name: user?.personalDetails?.name || '',
    address: user?.address?.street || '',
    mobileNumber: user.mobileNumber || '',
    inCategoryId: user?.facilityType?.[0] || '',
    countryCode: user?.address?.country || '',
    latitute: (user?.address?.latitute || '') + '' || '',
    longitute: (user?.address?.longitute || '') + '' || '',
    facilityManager:
      user.facilityManagers?.map((x) => ({ id: x.id, value: x.id, label: x.name })) ?? [],
    facilityStaff: user?.facilityStaff?.[0]?.id || '',
    // proofOfIdentity: filterSpecificData(user?.kycDocument, 'POE'),
    proofOfIdentity: filterSpecificData(user?.kycDocument, 'POI'),  // ✅ Match
    proofEstablishment_num: filterSpecificData(user?.kycDocument, 'POE', 'docType', 'docNumber'),
    proofOfIdentity_num: filterSpecificData(user?.kycDocument, 'POI', 'docType', 'docNumber'),
    // proofEstablishment: filterSpecificData(user?.kycDocument, 'POI'),
    proofEstablishment: filterSpecificData(user?.kycDocument, 'POE'),  // ✅ Match
    proofOfFacility: filterSpecificData(user?.kycDocument, 'POF'),
    // rigid: filterSpecificData(user?.diversionCapacity, 'Rigid', 'name', 'capacity'),
    rigid: user?.processingCapacity || '',
    flexible: filterSpecificData(user?.diversionCapacity, 'Flexible', 'name', 'capacity'),
    structureId: user.structureId || '',
    householdCapacity: user?.householdCapacity || '',
  })

  const [selectedThirdCertificationDropdown, setselectedThirdCertificationDropdown] = useState<any>(
    /* user?.facilityStaff?.map((x) => ({...x, label: x.name || x})) || */[]
  )
  useEffect(() => {
    if (user?.certifications?.length) {
      setselectedThirdCertificationDropdown(
        user.certifications.map((x) => ({
          value: x.id,
          label: x.certificationName,
        }))
      )
    }
  }, [user.certifications])

  const { auth } = useAuth()
  const hideForm = auth?.data?.userType === 'SMART_CENTRE' || false

  const [assignHubPlastic, setAssignHubPlastic] = useState([])
  const [userList, setUserList] = useState([])
  const [finishedGoodsList, setFinishedGoodsList] = useState<any>([])
  const [selectedInCategoryDropdown, setselectedInCategoryDropdown] = useState(
    /*  user?.facilityType?.map((x) => ({...x, label: x?.name || x})) ||  */[]
  )



  const [showKycSection, setShowKycSection] = useState(false)
  const [showOtherSection, setShowOtherSection] = useState(false)

  // useEffect(() => {
  //   if (user?.facilityType) {
  //     // console.log({ttt: user.facilityType})
  //     const changeData = user.facilityType.map((x) => ({
  //       label: mapDataForUser[x?.name || x],
  //       value: x.name || x,
  //     }))
  //     setselectedInCategoryDropdown(changeData)
  //   }
  // }, [user])



  // Add facilityTypeList as dependency



  useEffect(() => {
    // Create style element for placeholder
    const style = document.createElement('style');
    style.textContent = `
      .custom-input::placeholder {
        color: black !important;
        opacity: 1 !important;
      }
      .custom-input::-webkit-input-placeholder {
        color: black !important;
        opacity: 1 !important;
      }
      .custom-input::-moz-placeholder {
        color: black !important;
        opacity: 1 !important;
      }
      .custom-input:-ms-input-placeholder {
        color: black !important;
        opacity: 1 !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);


  const [rawMaterialList, setRawMaterialList] = useState<any>([])

  const { responseData: facilityTypeList } = useFetchCommon({ api: 'diversionDetails' })

  const { responseData: structureDropdown } = useFetchCommon({ api: 'structures', isDropDown: true })

  const { responseData: userListAPi } = useFetchCommon({
    api: 'users?page=0&size=10&type=PICKUP_POINT_STAFF',
    isDropDown: false,
  })
  const { responseData: diversionDetails } = useFetchCommon({
    api: 'materialProcesses?processType=DIVERSION',
  })
  const incentiveLevelSelections = [
    {
      "label": "Small Island",
      "value": "SMALL_ICELAND"
    },
    {
      "label": "Small Material Hub",
      "value": "SMALL_MH"
    },
    {
      "label": "Medium Material Hub",
      "value": "MEDIUM_MH"
    },
    {
      "label": "Large Material Hub",
      "value": "LARGE_MH"
    },
  ]
  const { responseData: certificationsLists } = useFetchCommon({
    api: 'certifications?status=ACTIVE',
    isDropDown: false,
  })
  const { responseData: auditorsList } = useFetchCommon({ api: 'auditors', isDropDown: false })
  const { responseData: weightScaleList } = useFetchCommon({
    api: 'weightscales?status=ACTIVE',
    label: ['model'],
  })
  const certificationListsss =
    certificationsLists?.map((x) => {
      return {
        label: x.certificationName,
        value: x.id,
      }
    }) || {}

  const userListsss =
    userListAPi?.map((x) => {
      return {
        label: x.personalDetails.name,
        value: x.id,
      }
    }) || []

  // const dropdownFacility =
  //   facilityTypeList?.facilityTypes?.map((x) => {
  //     return {
  //       label: facilityTypeList?.supplyChainFacility[x] || mapDataForUser[x] || '',
  //       value: x,
  //     }
  //   }) || []
  // Define your desired order
  const facilityOrder = [
    'Collection Point',
    'Material Recovery Facility',
    'Trader/ Aggregator',
    'Recycling Facility',
    'End Customer'
  ];

  // const dropdownFacility = (facilityTypeList?.facilityTypes?.map((x) => {
  //   return {
  //     label: mapDataForUser[x] || facilityTypeList?.supplyChainFacility[x] || '',
  //     value: x,
  //   }
  // }) || []).sort((a, b) => {
  //   const indexA = facilityOrder.indexOf(a.label);
  //   const indexB = facilityOrder.indexOf(b.label);

  //   // If both items are in the order array, sort by their position
  //   if (indexA !== -1 && indexB !== -1) {
  //     return indexA - indexB;
  //   }

  //   // If only one item is in the order array, prioritize it
  //   if (indexA !== -1) return -1;
  //   if (indexB !== -1) return 1;

  //   // If neither item is in the order array, maintain alphabetical order
  //   return a.label.localeCompare(b.label);
  // });



  // const dropdownFacility = facilityTypeList?.facilityTypes?.map((x) => {
  //   return {
  //     label: facilityTypeList?.supplyChainFacility[x] || '',
  //     value: x,  // Keep the enum as value for backend
  //   }
  // }) || []


  // const dropdownFacility = facilityTypeList?.facilityTypes
  //   ?.filter(x => x !== 'CONVERTER') // Add this filter to remove End Customer
  //   ?.map((x) => {
  //     return {
  //       label: facilityTypeList?.supplyChainFacility[x] || '',
  //       value: x,
  //     }
  //   }) || []


  const dropdownFacility = facilityTypeList?.facilityTypes
    ?.filter(x => x !== 'CONVERTER' && x !== 'FLEET')
    ?.map((x) => {
      // Custom labels
      let label = facilityTypeList?.supplyChainFacility[x] || ''

      if (x === 'COLLECTION_TYPE') {
        label = 'UBS'
      } else if (x === 'AGGREGATOR') {
        label = 'Waste Bank'
      } else if (x === 'FLEET') {
        label = 'FTS Collection Ecosystem'
      }
      else if (x === 'DIVERSION_FACILITY') {
        label = 'Recycling Facility'
      }
      else {
        label = x;
      }

      return {
        label: label,
        value: x,
      }
    }) || []


  const { data: response } = useQuery(
    'process',
    () => getUserById(null, 'users?page=0&size=10&type=FRANCHISE'),
    {
      cacheTime: 0,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
      enabled: true, // Set this to true to run the query once
    }
  )

  const [auditList, setAuditList] = useState<any>([])
  useEffect(() => {
    if (auditorsList?.length > 0) {
      // console.log('first')
      setAuditList(
        auditorsList.map((x) => {
          return {
            label: x.personalDetails.name,
            value: x.id,
          }
        })
      )
    }
  }, [auditorsList])

  useEffect(() => {
    if (response?.length) {
      const tempAllCategories = response.map((eachRes) => {
        return {
          label: eachRes?.personalDetails?.name || '',
          value: eachRes.id,
        }
      })
      setAssignHubPlastic(tempAllCategories)
    }
  }, [response])

  const { data: resp } = useQuery(
    'user_list',
    () => getUserById(null, 'certifications?page=0&size=10&status=ACTIVE'),
    {
      cacheTime: 0,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
      enabled: true, // Set this to true to run the query once
    }
  )

  useEffect(() => {
    if (resp?.length) {
      const tempAllCategories = resp.map((eachRes) => {
        return {
          label: eachRes?.certificationName || '',
          value: eachRes.id,
        }
      })
      setUserList(tempAllCategories)
      setFinishedGoodsList(tempAllCategories)
    }
  }, [resp])

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
  }

  interface DropdownOption {
    id?: string;
    value: string;
    label: string;
  }

  const [selectedOutCategoryDropdown, setselectedOutCategoryDropdown] = useState<DropdownOption[]>([])
  useEffect(() => {
    if (user?.facilityStaff?.length > 0) {
      const formattedStaff = user.facilityStaff.map((x) => ({
        value: x.id,
        label: x.name || x.personalDetails?.name || x
      }))
      setselectedOutCategoryDropdown(formattedStaff)
    }
  }, [user])


  const formik: any = useFormik({
    initialValues: userForEdit,
    validationSchema: editUserSchema(selectedInCategoryDropdown),
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        const payload = {
          password: '',
          // structureId: values.structureId || '',
          pprsCertificate: values.pprsCertificate,
          householdCapacity: values.householdCapacity ? Number(values.householdCapacity) : null,
          isoCertificate: values.isoCertificate,
          processingCapacity: values.rigid, // Add this line
          firstName: values.name,
          mobile: values.mobileNumber,
          middleName: '',
          lastName: '',
          userType: 'PICKUP_POINT',
          customerType: 'CORPORATE',
          address: {
            country: values.country,
            street: address || '',
            city: values.city,
            state: values.state,
            latitute: values.latitute,
            longitute: values.longitute,
          },
          kycDocument: [
            {
              docUrl: values?.proofEstablishment,
              docType: 'POE',
              docNumber: values?.proofEstablishment_num,
            },
            {
              docUrl: values?.proofOfIdentity,
              docType: 'POI',
              docNumber: values?.proofOfIdentity_num,
            },
            {
              docUrl: values?.proofOfFacility,
              docType: 'POF',
            },
          ],
          facilityType: selectedInCategoryDropdown.map((x: any) => x?.value || x),
          diversionType: values.diversionType,
          incentiveLevel: values.incentiveLevel,
          diversionCapacity: isContain
            ? [
              {
                id:
                  diversionDetails?.diversionCapacities?.filter((x) => x?.name === 'Rigid')[0]
                    ?.id || '',
                name: 'Rigid',
                capacity: values.rigid,
              },
              {
                id:
                  diversionDetails?.diversionCapacities?.filter((x) => x?.name === 'Flexible')[0]
                    ?.id || '',
                name: 'Flexible',
                capacity: values.flexible,
              },
            ]
            : [],
          /*  facilityManager: {
            id: values.facilityManager,
            name: filterUserList[0]?.label || '',
          }, */
          facilityManager: values.facilityManager.map((x) => ({
            id: x.value || '',
            name: x.label || '',
          })),
          franchiseId: values.franchiseId,
          certifications: selectedThirdCertificationDropdown?.map((x) => {
            return x.value
          }),
          weightScale: values.weightScale,
          structureId: values.structureId,
          auditorId: values.auditorStaff,
          auditorName: auditList.filter((x) => x.value === values.auditorStaff)?.[0]?.label || '',
          facilityStaff: selectedOutCategoryDropdown.map((x) => {
            return {
              id: x.id || x.value,
              name: x.label,
            }
          }),
        }
        if (isNotEmpty(values.id)) {
          await updateUser(payload, `users/${values.id}/update`)
          successToast('Modified')
          cancel(true)
        } else {
          await createUser(payload, 'user/register')
          successToast('Added')
          cancel(true)
        }
      } catch (ex) {
        errorToast('Somethig Went Wrong')
        console.error(ex)
      } finally {
        setSubmitting(true)
      }
    },
  })



  useEffect(() => {
    const facilityLevelMap = {
      COLLECTION_TYPE: 'UBS',
      AGGREGATOR: 'Waste Bank',
      FLEET: 'FTS Collection Ecosystem',
      DIVERSION_FACILITY: 'Recycling Facility',
    }

    if (user?.facilityType && facilityTypeList?.supplyChainFacility) {
      const changeData = user.facilityType.map((x) => ({
        label: facilityLevelMap[x] || x,
        value: x,
      }))
      setselectedInCategoryDropdown(changeData)
    }
  }, [user, facilityTypeList])



  // const inputForm = ({
  //   label,
  //   name,
  //   placeholder,
  //   required = true,
  //   className = 'fw-bold fs-6 mb-2',
  // }) => {
  //   return (
  //     <div className='fv-row mb-7'>
  //       <label className={`${required ? 'required' : ''} ${className}`}>{label}</label>
  //       <input
  //         placeholder={placeholder}
  //         {...formik.getFieldProps(name)}
  //         type='text'
  //         name={name}
  //         className={clsx(
  //           'form-control form-control-solid mb-3 mb-lg-0 custom-input',
  //           { 'is-invalid': formik.touched[name] && formik.errors[name] },
  //           {
  //             'is-valid': (required && formik.touched[name] && !formik.errors[name]) || '',
  //           }
  //         )}
  //         style={{
  //           backgroundColor: 'white',
  //           border: '1px solid #cdcdcd',
  //           color: 'black'
  //         }}
  //         autoComplete='off'
  //         disabled={formik.isSubmitting || isUserLoading}
  //       />
  //       {formik.touched[name] && formik.errors[name] && (
  //         <div className='fv-plugins-message-container'>
  //           <div className='fv-help-block'>
  //             <span role='alert'>{formik.errors[name]}</span>
  //           </div>
  //         </div>
  //       )}
  //     </div>
  //   )
  // }

  const inputForm = ({
    label,
    name,
    placeholder,
    required = true,
    className = 'fw-bold fs-6 mb-2',
    type = 'text'
  }) => {
    return (
      <div className='fv-row mb-7'>
        <label className={`${required ? 'required' : ''} ${className}`}>{label}</label>
        <input
          placeholder={placeholder}
          {...formik.getFieldProps(name)}
          type={type}
          name={name}
          className={clsx(
            'form-control form-control-solid mb-3 mb-lg-0',
            { 'is-invalid': formik.touched[name] && formik.errors[name] },
            {
              'is-valid': (required && formik.touched[name] && !formik.errors[name]) || '',
            }
          )}
          style={{
            backgroundColor: 'white',
            border: '1px solid #cdcdcd',
            color: 'black'
          }}
          autoComplete='off'
          disabled={formik.isSubmitting || isUserLoading}
        />
        <style>{`
          .form-control::placeholder {
            color: #9da4ba !important;
          }
        `}</style>
        {formik.touched[name] && formik.errors[name] && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors[name]}</span>
            </div>
          </div>
        )}
      </div>
    )
  }



  // const makeSelectDropDown = (name = '', options: any = [], showTick = true) => {
  //   return (
  //     <>
  //       <select
  //         className={clsx(
  //           'form-control form-control-solid mb-3 mb-lg-0',
  //           { 'is-invalid': formik.touched[name] && formik.errors[name] },
  //           {
  //             'is-valid': (showTick && formik.touched[name] && !formik.errors[name]) || '',
  //           }
  //         )}
  //         style={{
  //           backgroundColor: 'white',
  //           border: '1px solid #cdcdcd',
  //           color: 'black'
  //         }}
  //         {...formik.getFieldProps(name)}
  //       >
  //         <option value=''>Select one...</option>
  //         {options.map((eachOption, eachInd) => (
  //           <option key={eachInd + 1 + ''} value={eachOption.value}>
  //             {eachOption.label}
  //           </option>
  //         ))}
  //       </select>
  //       {formik.errors[name] && (
  //         <div className='fv-plugins-message-container'>
  //           <div className='fv-help-block'>
  //             <span role='alert'>{formik.errors[name]}</span>
  //           </div>
  //         </div>
  //       )}
  //     </>
  //   )
  // }


  const makeSelectDropDown = (name = '', options: any = [], showTick = true) => {
    return (
      <>
        <select
          className={clsx(
            'form-control form-control-solid mb-3 mb-lg-0',
            { 'is-invalid': formik.touched[name] && formik.errors[name] },
            {
              'is-valid': (showTick && formik.touched[name] && !formik.errors[name]) || '',
            }
          )}
          style={{
            backgroundColor: 'white',
            border: '1px solid #cdcdcd',
            color: formik.values[name] ? 'black' : '#9da4ba'
          }}
          {...formik.getFieldProps(name)}
        >
          <option value='' style={{ color: '#9da4ba' }}>Select one...</option>
          {options.map((eachOption, eachInd) => (
            <option key={eachInd + 1 + ''} value={eachOption.value} style={{ color: 'black' }}>
              {eachOption.label}
            </option>
          ))}
        </select>
        {formik.errors[name] && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors[name]}</span>
            </div>
          </div>
        )}
      </>
    )
  }


  const handleSelect = (e, options, name, action) => {

    if (name === 'inCategoryId' && action.action === 'remove-value' && action.removedValue?.value === 'CONVERTER') {
      return; // Don't allow removal
    }


    if (name === 'inCategoryId') {
      setselectedInCategoryDropdown(e)
    } else if (name === 'certifications') {
      setselectedThirdCertificationDropdown(e)
    } else if (name === 'facilityManager') {
      formik.setFieldValue('facilityManager', e)
    } else {
      setselectedOutCategoryDropdown(e)
    }
    if (name !== 'facilityManager') {
      if (action.removedValue?.length) {
        formik.setFieldValue(
          name === 'inCategoryId'
            ? 'inMaterials'
            : name === 'certifications'
              ? 'certifications'
              : 'outMaterials',
          []
        )
        setRawMaterialList([])
      } else if (action?.removedValue) {
        const newFilteredData: any = (
          name === 'inCategoryId' ? rawMaterialList : finishedGoodsList
        )?.filter((x) => x.categoryId !== action.removedValue.id)
        const filterInOutCategory = formik.values[
          name === 'inCategoryId' ? 'inMaterials' : 'outMaterials'
        ]?.filter((x) => x.categoryId !== action.removedValue.id)
        formik.setFieldValue('inMaterials', filterInOutCategory)
        name === 'inCategoryId'
          ? setRawMaterialList(newFilteredData)
          : setFinishedGoodsList(newFilteredData)
      } else {
        const value = e[e.length - 1]?.value || ''
        const filter = options?.filter((x) => x.value === value)
        if (name === 'inCategoryId' && filter.length) {
          formik.setFieldValue('inCategoryName', filter[0]?.name || '')
        } else if (name === 'certifications' && filter.length) {
          formik.setFieldValue('certifications', filter[0]?.name || '')
        } else {
          if (filter.length) {
            formik.setFieldValue('outCategoryName', filter[0]?.name || '')
          }
        }
        formik.setFieldValue([name], value)
      }
    }
  }

  // const multiSelect = (name = '', options: any = [], value) => {
  //   return (
  //     <>
  //       <Select
  //         isMulti
  //         name={name}
  //         options={options}
  //         className='basic-multi-select'
  //         classNamePrefix='select'
  //         value={value}
  //         onChange={(selected, action) => handleSelect(selected, options, name, action)}
  //       />
  //       {formik?.errors?.[name] && (
  //         <div className='fv-plugins-message-container'>
  //           <div className='fv-help-block'>
  //             <span role='alert'>{formik?.errors[name]}</span>
  //           </div>
  //         </div>
  //       )}
  //     </>
  //   )
  // }

  // const dropdownDiverison =
  //   diversionDetails?.diversionTypes?.map((x) => {
  //     return {
  //       label: x,
  //       value: x,
  //     }
  //   }) || []


  const multiSelect = (name = '', options: any = [], value) => {
    // Check if End Customer is selected and limit to single selection
    const isEndCustomerSelected = name === 'inCategoryId' && value?.some((item: any) => item.value === 'CONVERTER');

    return (
      <>
        <Select
          isMulti
          name={name}
          options={options}
          className='basic-multi-select'
          classNamePrefix='select'
          value={value}
          onChange={(selected, action) => {
            // If End Customer is being added, only allow that selection
            if (name === 'inCategoryId' && action.action === 'select-option' && action.option?.value === 'CONVERTER') {
              handleSelect([action.option], options, name, action);
            }
            // If End Customer is already selected and user tries to add more, prevent it
            else if (name === 'inCategoryId' && isEndCustomerSelected && action.action === 'select-option') {
              return; // Don't allow additional selections
            }
            // Normal handling for other cases
            else {
              handleSelect(selected, options, name, action);
            }
          }}
        />
        {formik?.errors?.[name] && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik?.errors[name]}</span>
            </div>
          </div>
        )}
      </>
    )
  }



  const assignData = Object.assign([], selectedInCategoryDropdown)
  const isContain = JSON.stringify(assignData).includes('Recycling Facility')
  // console.log({
  //   selectedInCategoryDropdown,
  //   test: selectedInCategoryDropdown?.filter((x: any) => x.label === 'DIVERSION_FACILITY'),
  //   forrr: formik.errors,
  //   forr: formik.values,
  //   hello: selectedInCategoryDropdown?.some(
  //     (item: {label: string; value: string}) => item?.value === 'CONVERTER'
  //   ),
  // })
  return (
    <>
      <form id='kt_modal_add_user_form' className='form' onSubmit={formik.handleSubmit} noValidate>
        {/* <h3 className="mb-4 fw-bold">Basic information</h3> */}
        <div className='grid grid-cols-2 gap-2'>
          {inputForm({ label: 'Material Hub name', name: 'name', placeholder: 'Enter Material Hub name' })}
          {hideForm && (
            <div className='fv-row mb-7'>
              <label className='fw-bold fs-6 mb-2 required'>EXN MEMBER</label>
              {makeSelectDropDown('franchiseId', assignHubPlastic)}
            </div>
          )}
          {inputForm({
            label: 'Household capacity',
            name: 'householdCapacity',
            placeholder: 'Enter household capacity',
            type: 'number',
            required: false,
          })}
        </div>
        <div className={`grid grid-cols-2 gap-2`}>
          <div className='fv-row mb-7'>
            <label className='fw-bold fs-6 mb-2 required'>Hub type</label>
            {multiSelect('inCategoryId', dropdownFacility, selectedInCategoryDropdown)}
            {/* {multiSelect(
              'inCategoryId',
              dropdownFacility,
              selectedInCategoryDropdown,
              selectedInCategoryDropdown?.some((item: any) => item.value === 'CONVERTER')
            )} */}
          </div>
          {(selectedInCategoryDropdown?.filter((x: any) => x.label === 'Recycling Facility')
            ?.length && (
              <div className='fv-row mb-7'>
                <label className='fw-bold fs-6 mb-2 required'>Recycling Process</label>
                {makeSelectDropDown('diversionType', diversionDetails)}
              </div>
            )) ||
            null}
        </div>
        <div className={`grid grid-cols-1`}>
          <div className='fv-row mb-7'>
            <label className='fw-bold fs-6 mb-2 required'>Select incentive level</label>
            {makeSelectDropDown('incentiveLevel', incentiveLevelSelections)}
          </div>

        </div>








        {selectedInCategoryDropdown?.some(
          (item: { label: string; value: string }) => item?.value === 'CONVERTER'
        ) ? (
          ''
        ) : (
          <div className='grid grid-cols-2 gap-2'>
            <div className='fv-row mb-7'>
              <label className='fw-bold required fs-6 mb-2'>Hub manager</label>
              {/* {makeSelectDropDown('facilityManager', userListsss)} */}
              {multiSelect('facilityManager', userListsss, formik?.values?.facilityManager || [])}
            </div>
            <div className='fv-row mb-7'>
              <label className='required fw-bold fs-6 mb-2'>Hub app users</label>
              {multiSelect('facilityStaff', userListsss, selectedOutCategoryDropdown)}
            </div>
          </div>
        )}




        {/* {(isContain && (
          <div className='grid grid-cols-2 gap-2'>
            {inputForm({
              label: 'Rigid',
              name: 'rigid',
              placeholder: 'Enter diversion capacity in tons per annum',
            })}
            <div className='fv-row mb-7'>
              {inputForm({
                label: 'Flexible',
                name: 'flexible',
                placeholder: 'Enter diversion capacity in tons per annum',
              })}
            </div>
          </div>
        )) ||
          null} */}
        <div className='grid grid-cols-2 gap-2'>
          {inputForm({
            label: 'Annual processing capacity (matric tons)',
            name: 'rigid',
            placeholder: 'Enter only values',
            required: selectedInCategoryDropdown?.some((x: any) => x.value === 'DIVERSION_FACILITY')
              ? true
              : false,
          })}
          <CountryDropDown showState showCity name='country' formik={formik} showNameOnly />
        </div>
        <div className='grid'>
          <div className='fv-row mb-7'>
            <label className=' fw-bold fs-6 mb-2'>Street</label>
            <AutoCompleteAddress
              address={address}
              setAddress={setAddress}
              location={location}
              formik={formik}
              setlocation={setlocation}
            />
            {formik.errors.address && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.address}</span>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className='grid grid-cols-2 gap-2'>
          {inputForm({ label: 'Latitude', name: 'latitute', placeholder: 'Enter Latitude' })}
          {inputForm({ label: 'Longitude', name: 'longitute', placeholder: 'Enter Longitude' })}
        </div>
        {/* <div className='grid grid-cols-2 gap-2'>
          {inputForm({
            required: false,
            label: 'Business Identification Number',
            name: 'proofEstablishment_num',
            placeholder: 'Enter Business Identification Number',
          })}
          {inputForm({
            required: false,
            className: 'fw-bold fs-7 mb-2',
            label: 'National EPR Reg No/Environment Clearance No',
            name: 'proofOfIdentity_num',
            placeholder: 'Enter National EPR Reg No/Environment Clearance No',
          })}
        </div> */}

        {/* <div className='fv-row mb-7'>
          <label className='fw-bold fs-6 mb-2'>Assign Certifications</label>
          {multiSelect('certifications', certificationListsss, selectedThirdCertificationDropdown)}
        </div> */}




        {/* Update business KYC information Section */}
        <div className='card p-4 mb-4' style={{ backgroundColor: '#f5f5f5' }}>
          <div className='d-flex justify-content-between align-items-center'>
            <h4 className="mb-0 fw-bold">Update business KYC information</h4>
            <div className="d-flex gap-4">
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="showKyc"
                  id="kycNo"
                  checked={!showKycSection}
                  onChange={() => setShowKycSection(false)}
                />
                <label className="form-check-label" htmlFor="kycNo">No</label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="showKyc"
                  id="kycYes"
                  checked={showKycSection}
                  onChange={() => setShowKycSection(true)}
                />
                <label className="form-check-label" htmlFor="kycYes">Yes</label>
              </div>
            </div>
          </div>
        </div>

        {showKycSection && (
          <>
            <div className='grid grid-cols-2 gap-2'>
              {inputForm({
                required: false,
                label: 'Business Identification Number',
                name: 'proofEstablishment_num',
                placeholder: 'Enter Business Identification Number',
              })}
              {/* {inputForm({
                required: false,
                className: 'fw-bold fs-7 mb-2',
                label: 'National EPR Reg No/Environment Clearance No',
                name: 'proofOfIdentity_num',
                placeholder: 'Enter National EPR Reg No/Environment Clearance No',
              })} */}
            </div>
            <div className='fv-row mb-7'>
              <label className='fw-bold fs-6 mb-2'>Assign Certifications</label>
              {multiSelect('certifications', certificationListsss, selectedThirdCertificationDropdown)}
            </div>
            <div className='grid grid-cols-3 gap-2'>
              <UploadImage
                name='proofEstablishment'
                required={false}
                formik={formik}
                label='Hub Picture'
              />
              <UploadImage
                required={false}
                name='proofOfIdentity'
                formik={formik}
                label='Environmental Permit'
              />
              <UploadImage
                required={false}
                name='proofOfFacility'
                formik={formik}
                label='Hub Logo'
              />
            </div>
          </>
        )}





        {/* Other information Section */}
        <div className='card p-4 mb-4' style={{ backgroundColor: '#f5f5f5' }}>
          <div className='d-flex justify-content-between align-items-center'>
            <h4 className="mb-0 fw-bold">Other information</h4>
            <div className="d-flex gap-4">
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="showOther"
                  id="otherNo"
                  checked={!showOtherSection}
                  onChange={() => setShowOtherSection(false)}
                />
                <label className="form-check-label" htmlFor="otherNo">No</label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="showOther"
                  id="otherYes"
                  checked={showOtherSection}
                  onChange={() => setShowOtherSection(true)}
                />
                <label className="form-check-label" htmlFor="otherYes">Yes</label>
              </div>
            </div>
          </div>
        </div>

        {showOtherSection && (
          <div className='grid grid-cols-3 gap-2'>
            <div className='fv-row mb-7'>
              <label className='fw-bold fs-6 mb-2'>Assign Auditor</label>
              {makeSelectDropDown('auditorStaff', auditList, false)}
            </div>
            <div className='fv-row mb-7'>
              <label className='fw-bold fs-6 mb-2'>Assign Weight Scale</label>
              {makeSelectDropDown('weightScale', weightScaleList, false)}
            </div>
            <div className='fv-row mb-7'>
              <label className='fw-bold fs-6 mb-2'>Price Template</label>
              {makeSelectDropDown('structureId', structureDropdown, false)}
            </div>
          </div>
        )}






        {/* <div className='grid grid-cols-3 gap-2'>
          <div className='fv-row mb-7'>
            <label className='fw-bold fs-6 mb-2'>Assign Auditor</label>
            {makeSelectDropDown('auditorStaff', auditList, false)}
          </div>
          <div className='fv-row mb-7'>
            <label className='fw-bold fs-6 mb-2'>Assign Weight Scale</label>
            {makeSelectDropDown('weightScale', weightScaleList, false)}
          </div>
          <div className='fv-row mb-7'>
            <label className='fw-bold fs-6 mb-2'>Price Template</label>
            {makeSelectDropDown('structureId', structureDropdown, false)}
          </div>
        </div> */}
        {/* <div className='grid grid-cols-3 gap-2'>
          <UploadImage
            name='proofEstablishment'
            required={false}
            formik={formik}
            label='Facility Picture'
          />
          <UploadImage
            required={false}
            name='proofOfIdentity'
            formik={formik}
            label='Environmental Permit'
          />
          <UploadImage
            required={false}
            name='proofOfFacility'
            formik={formik}
            label='Facility Logo'
          />
        </div> */}
        <div className='text-center pt-15'>
          <button
            type='reset'
            onClick={() => cancel()}
            className='btn btn-light me-3'
            data-kt-users-modal-action='cancel'
            disabled={formik.isSubmitting || isUserLoading}
          >
            Discard
          </button>

          <button
            type='submit'
            className='btn btn-primary'
            data-kt-users-modal-action='submit'
            style={{ backgroundColor: 'black' }}
            disabled={isUserLoading || formik.isSubmitting || !formik.isValid || !formik.touched}
          >
            <span className='indicator-label'>Submit</span>
            {(formik.isSubmitting || isUserLoading) && (
              <span className='indicator-progress'>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </form>
      {(formik.isSubmitting || isUserLoading) && <UsersListLoading />}
    </>
  )
}

export default UnitMeasurementModalForm
